import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";
import { map } from "rxjs/operators";

export interface TimeOffFormData {
  id?: number,
  assignmentType: 'Rep' | 'Random';
  assignHolidaysLeads: number | string[];
  type: 'bydate' | 'permanent';
  startDate?: string | Date;
  hrInicio?: string;
  endDate?: string | Date;
  hrFin?: string;
  applyTo?: string;
}

@Injectable({
  providedIn: "root",
})
export class CompanylinkedService {
  public url: any;

  constructor(private http: HttpClient) {
    this.url = GLOBAL.url;
  }

 create(token: any, task: any): Observable<any> {

    const params = {
      json: encodeURIComponent(JSON.stringify(task)),
      authorization: token,
    };
    const headers = this.createHeaders();
 
    return this.http.post<any>(
      `${this.url}/company/new?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }


  editIntegrations(token: any, task: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/editintegrations?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  validateCompany(token: any, valor: any): Observable<any> {
    const params = {
      json: JSON.stringify({ cvCode: valor }),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/checkcvcode`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getCompany(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/detail/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getOverallStats(token: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/overallstats`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getCompanyByPo(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/companybypo/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getAllCompaniesLite(token: any, type: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/alllistlite/${type}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  update(token: any, task: any, id: any): Observable<any> {
    const params = {
      json: encodeURIComponent(JSON.stringify(task)),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/edit/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  updatebyparam(token: any, task: any, id: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/updatebyparam/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getCompanies(token: any, page = 1, activos: any = 1 ,filtros: any[] = [],pageLimit:any = null): Observable<any> {
    const task = {
      active: String(activos),
    };
    const params = {
      json: JSON.stringify(task),
      authorization: token,
    };
    let queryParams = `?page=${page}`;
    filtros.forEach(filtro => {
      if (filtro && filtro.value) {
        queryParams += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        if (filtro.key_type) {
          queryParams += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
        }
      }
    });
    const headers = this.createHeaders();
    const endpoint = `/company/list?page=${page}${queryParams}`;
    const body = `json=${encodeURIComponent(JSON.stringify({ active: String(activos), pagelimit: pageLimit}))}&authorization=${token}`;
    return this.http.post(`${this.url}${endpoint}`, body, { headers })
    .pipe(map(res => res));
/*     return this.http.post<any>(
      `${this.url}/company/list?page=${page}`,
      this.buildSearchParams(params),
      { headers }
    ); */
  }

  getNewCompanies(token: any, page = 1, activos: any = 1 ,filtros: any[] = [],pageLimit:any = null, task2:any,
    order:any): Observable<any> {
    const task = {
      active: String(activos),
    };
    const params = {
      json: JSON.stringify(task),
      authorization: token,
    };
    let queryParams = `?page=${page}`;
    filtros.forEach(filtro => {
      if (filtro && filtro.value) {
        queryParams += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        if (filtro.key_type) {
          queryParams += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
        }
      }
    });
    const headers = this.createHeaders();
    const endpoint = `/company/list?page=${page}${queryParams}`;
    const body = `json=${encodeURIComponent(JSON.stringify({ active: String(activos), pagelimit: pageLimit, sort:task2, order:order}))}&authorization=${token}`;
    return this.http.post(`${this.url}${endpoint}`, body, { headers })
    .pipe(map(res => res));
/*     return this.http.post<any>(
      `${this.url}/company/list?page=${page}`,
      this.buildSearchParams(params),
      { headers }
    ); */
  }

  getRandomValues(token: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/user/listreproles`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getRepsValues(token: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/user/alllistlite/exceptuser`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  deleteCompany(token: any, id: any, task: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/remove/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  updateMultiple(token: any, task: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/updateMultiple`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getCompanySetup(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/detailsetup/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  editCompanySetup(token: any, task: any, id: any): Observable<any> {
    const params = {
      json: encodeURIComponent(JSON.stringify(task)),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/editsetup/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  postTimeOff(token: string, timeOffForm: TimeOffFormData): Observable<any> {
    const body = encodeURIComponent(JSON.stringify(timeOffForm));
    return this.http.post<any>(`${this.url}/holidaysmodedata/new?authorization=${token}&json=${body}`, {});
  }

  getHDModeData(token: string): Observable<any> {
    return this.http.post<any>(`${this.url}/holidaysmodedata/list?authorization=${token}`, {});
  }
  
  deleteTimeOff(token: string, id:number): Observable<any> {
    return this.http.post<any>(`${this.url}/holidaysmodedata/remove/${id}?authorization=${token}`, {});
  }

  getDetailTimeOff(token: string, id:number): Observable<any> {
    return this.http.post<any>(`${this.url}/holidaysmodedata/detail/${id}?authorization=${token}`, {});
  }

  updateTimeOff(token: string, timeOffForm: TimeOffFormData, id: number): Observable<any> {
    const body = encodeURIComponent(JSON.stringify(timeOffForm));
    return this.http.post<any>(`${this.url}/holidaysmodedata/edit/${id}?authorization=${token}&json=${body}`, {});
  }

  getDetailStatusHDMode(token: string): Observable<any> {
    return this.http.post<any>(`${this.url}/company/detailsetup/4?page=1&authorization=${token}`, {});
  }

  updateByParam(token: any, task: any, id: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/updatebyparam/3`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  setContactPartyPickup(token: any, company: any): Observable<any> {
    const params = {
      json: JSON.stringify(company),
      authorization: token,
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/company/setcontactpartypickup?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  private createHeaders(): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  private buildSearchParams(params: any): any {
    return Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&");
  }
}
